import { AccountService } from 'app/store/services/account.service';
import { IReducers } from './../../../store/reducers/index';
import { Component, Inject, OnInit } from '@angular/core';
import { IAccount } from 'app/store/models/account.model';
import { Store } from '@ngrx/store';
import { openDialog, openSnackbar } from 'app/store/actions/page.action';
import { AccountsUnderComponent } from '../accounts-under/accounts-under.component';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { TABLE_COMPONENT, TableComponent } from '../../../shared/ui/table/table.component';

@Component({
  selector: 'app-partner-control',
  templateUrl: './partner-control.component.html',
  styleUrls: ['./partner-control.component.scss'],
})
export class PartnerControlComponent implements OnInit {
  public column: IAccount;
  public partners: IAccount[];

  viewRepButtonProperties: Button = {
    text: 'View Reps',
    color: ButtonColor.ORANGE,
    size: ButtonSize.NORMAL,
    style: 'rounded',
    onClick: () => this.openDialog()
  }

  constructor(
    private store: Store<IReducers>,
    private accountService: AccountService,
    @Inject(TABLE_COMPONENT) private tableComponent: TableComponent,
  ) {
  }

  ngOnInit() {
  }

  getPartners() {
    return this.partners.map(manager => {
      return {
        label: manager.email,
        value: manager.account_id,
      };
    });
  }

  onPartnerSelect(partnerId) {
    if (!partnerId) {
      return;
    }
    this.accountService
      .setAccountPartner(this.column.account_id, partnerId)
      .subscribe(
        () => {
          this.tableComponent.refresh();
          this.store.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  message: 'Account settings successfully changed',
                  type: 'success',
                },
              },
            }),
          );
        },
        error =>
          this.store.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  message: error.error,
                  type: 'error',
                },
              },
            }),
          ),
      );
  }

  openDialog() {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: `User Account(s) under ${this.column.first_name} ${this.column.last_name}`,
          content: AccountsUnderComponent,
          componentData: {
            items: this.column.visible_users,
            account: this.column
          },
          dialogMinWidth: '1000px',
          canClose: true,
        },
      }),
    );
  }

  resetPartner() {
    this.store.dispatch(
      openDialog({
        dialogData: {
          content: `Are you sure you want to remove ${this.column.partner_id} from ${this.column.account_id}?`,
          title: 'Remove Partner',
          canClose: true,
          buttons: [
            {
              text: 'Remove',
              color: ButtonColor.RED,
              size: ButtonSize.NORMAL,
              onClick: dialog => {
                this.accountService
                  .setAccountPartner(this.column.account_id, null)
                  .subscribe(
                    () => {
                      dialog.closeDialog();
                      this.tableComponent.refresh();
                      this.store.dispatch(
                        openSnackbar({
                          snackbarData: {
                            data: {
                              message: 'Account settings successfully changed',
                              type: 'success',
                            },
                          },
                        }),
                      );
                    },
                    error =>
                      this.store.dispatch(
                        openSnackbar({
                          snackbarData: {
                            data: {
                              message: error.error,
                              type: 'error',
                            },
                          },
                        }),
                      ),
                  );
              },
            },
          ],
        },
      }),
    );
  }
}
